import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Timeline from "./components/Timeline";
import TestsGrid from "./components/TestsGrid";
import Footer from "./components/Footer";
import Gallery from "./components/Gallery";
import Prizes from "./components/Prizes";

import Partners from "./components/Partners";
  

export default function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <About />
        <Timeline />
        <Prizes/>
        <TestsGrid />
        <Gallery/>
         <Partners/>
      </main>
      <Footer />
    </>
  );
}
